class Config {
    constructor() {
        this.backendHost = process.env.NODE_ENV === "development" ? "http://localhost:44369" : "/b";
        this.currencyFormat = "0[.]00 $";
        this.grammagesFormat = "0[.]00";
        this.imageStorageBlobURL = "https://ggbiosmedia.blob.core.windows.net/ggbiosmedia/";

        this.apiUrl = "https://functions.foodgenius.ai/v1-dev";
        // local development
        // this.apiUrl = "http://localhost:7071/v1-dev";

        this.coreModule = "core";
        this.licmanKey = "dev-licman";
    }
}

export default Config;
